import sectionReviewTitanCss from '../css-snippets/section-review-titan';

const html = `
<style>${sectionReviewTitanCss}</style>
<div data-attribute="card-container" id="card-container-unique-id" data-id="unique-id" data-background="#ffffff"
  data-top-padding="true" data-bottom-padding="true" data-background-image="" style="background-color: #ffffff"
  data-text-color="#000000">
  <div class="container-page" data-attribute="container-page" data-show-style="false" data-background="#FFFFFF"
    style="background-color: transparent;">
    <div class="container">
      <div class="wrap-card">
        <div data-attribute="title-card" class="title-card"></div>
        <div>
          <div data-attribute="body-review" class="body-review swiper" data-col-per-view="4">
            <div class="review-slider swiper-wrapper">
              <div data-attribute="item-review" class="item-review swiper-slide">
                <div class="content-item">
                  <div class="review-image-container">
                    <img loading="lazy" data-attribute="review-image"
                      src="https://cdn.skyfastimg.com/images/2026/03/20/image-69bcb88ea6fdfd932ad203a8.png?w=400&h=50&q=80"
                      alt="review image" class="review-image">
                  </div>
                  <div class="review-content">
                    <div data-attribute="wrap-stars" class="wrap-stars" data-value="2">
                      <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                          fill="#F9AC07" />
                      </svg>
                      <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                          fill="#F9AC07" />
                      </svg>
                    </div>
                    <div class="review-content-text" data-attribute="review-content">
                      <h3>“Finally underwear that actually works.”</h3>
                      <p>"The breathable fabric makes a noticeable difference, especially during hot days."</p>
                    </div>
                    <div class="review-name" data-attribute="review-name">Chloe S.</div>
                    <div class="verified-buyer">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M7.975 0L9.60625 1.8125L11.9625 1.0875L12.5063 3.44375L14.8625 3.9875L14.1375 6.34375L15.95 7.975L14.1375 9.60625L14.8625 11.9625L12.5063 12.5063L11.9625 14.8625L9.60625 14.1375L7.975 15.95L6.34375 14.1375L3.9875 14.8625L3.44375 12.5063L1.0875 11.9625L1.8125 9.60625L0 7.975L1.8125 6.34375L1.0875 3.9875L3.44375 3.44375L3.9875 1.0875L6.34375 1.8125L7.975 0Z"
                          fill="#42ADA4" />
                        <path
                          d="M11.8173 4.56738L6.88729 9.49738L4.85728 7.46738L3.84229 8.48238L6.88729 11.5274L12.8323 5.58238L11.8173 4.56738Z"
                          fill="#E3F2FD" />
                      </svg>
                      <span>verified buyer</span>
                    </div>
                  </div>
                </div>
              </div>
              <div data-attribute="item-review" class="item-review swiper-slide">
                <div class="content-item">
                  <div class="review-image-container">
                    <img loading="lazy" data-attribute="review-image"
                      src="https://cdn.skyfastimg.com/images/2026/03/20/image-69bcc074c9d5b16c4ce85865.png?w=400&h=50&q=80"
                      alt="review image" class="review-image">
                  </div>
                  <div class="review-content">
                    <div data-attribute="wrap-stars" class="wrap-stars" data-value="3">
                      <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                          fill="#F9AC07" />
                      </svg>
                      <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                          fill="#F9AC07" />
                      </svg>
                      <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                          fill="#F9AC07" />
                      </svg>
                    </div>
                    <div class="review-content-text" data-attribute="review-content">
                      <h3>“No more embarrassing moments.”</h3>
                      <p>"I ordered these as a gift and now my husband asks me to buy more. That’s the best review I can
                        give."</p>
                    </div>
                    <div class="review-name" data-attribute="review-name">Chloe S.</div>
                    <div class="verified-buyer">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M7.975 0L9.60625 1.8125L11.9625 1.0875L12.5063 3.44375L14.8625 3.9875L14.1375 6.34375L15.95 7.975L14.1375 9.60625L14.8625 11.9625L12.5063 12.5063L11.9625 14.8625L9.60625 14.1375L7.975 15.95L6.34375 14.1375L3.9875 14.8625L3.44375 12.5063L1.0875 11.9625L1.8125 9.60625L0 7.975L1.8125 6.34375L1.0875 3.9875L3.44375 3.44375L3.9875 1.0875L6.34375 1.8125L7.975 0Z"
                          fill="#42ADA4" />
                        <path
                          d="M11.8173 4.56738L6.88729 9.49738L4.85728 7.46738L3.84229 8.48238L6.88729 11.5274L12.8323 5.58238L11.8173 4.56738Z"
                          fill="#E3F2FD" />
                      </svg>
                      <span>verified buyer</span>
                    </div>
                  </div>
                </div>
              </div>
              <div data-attribute="item-review" class="item-review swiper-slide">
                <div class="content-item">
                  <div class="review-image-container">
                    <img loading="lazy" data-attribute="review-image"
                      src="https://cdn.skyfastimg.com/images/2026/03/20/image-69bcc080f53e5ba6e957549a.png?w=400&h=50&q=80"
                      alt="review image" class="review-image">
                  </div>
                  <div class="review-content">
                    <div data-attribute="wrap-stars" class="wrap-stars" data-value="4">
                      <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                          fill="#F9AC07" />
                      </svg>
                      <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                          fill="#F9AC07" />
                      </svg>
                      <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                          fill="#F9AC07" />
                      </svg>
                      <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                          fill="#F9AC07" />
                      </svg>
                    </div>
                    <div class="review-content-text" data-attribute="review-content">
                      <h3>“They look like normal boxer briefs.”</h3>
                      <p>"Comfortable, breathable, and they actually look good. That’s a rare combination."</p>
                    </div>
                    <div class="review-name" data-attribute="review-name">Danielle R.</div>
                    <div class="verified-buyer">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M7.975 0L9.60625 1.8125L11.9625 1.0875L12.5063 3.44375L14.8625 3.9875L14.1375 6.34375L15.95 7.975L14.1375 9.60625L14.8625 11.9625L12.5063 12.5063L11.9625 14.8625L9.60625 14.1375L7.975 15.95L6.34375 14.1375L3.9875 14.8625L3.44375 12.5063L1.0875 11.9625L1.8125 9.60625L0 7.975L1.8125 6.34375L1.0875 3.9875L3.44375 3.44375L3.9875 1.0875L6.34375 1.8125L7.975 0Z"
                          fill="#42ADA4" />
                        <path
                          d="M11.8173 4.56738L6.88729 9.49738L4.85728 7.46738L3.84229 8.48238L6.88729 11.5274L12.8323 5.58238L11.8173 4.56738Z"
                          fill="#E3F2FD" />
                      </svg>
                      <span>verified buyer</span>
                    </div>
                  </div>
                </div>
              </div>
              <div data-attribute="item-review" class="item-review swiper-slide">
                <div class="content-item">
                  <div class="review-image-container">
                    <img loading="lazy" data-attribute="review-image"
                      src="https://cdn.skyfastimg.com/images/2026/03/20/image-69bcc0892ddad94d2a1fa42d.png?w=400&h=50&q=80"
                      alt="review image" class="review-image">
                  </div>
                  <div class="review-content">
                    <div data-attribute="wrap-stars" class="wrap-stars" data-value="5">
                      <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                          fill="#F9AC07" />
                      </svg>
                      <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                          fill="#F9AC07" />
                      </svg>
                      <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                          fill="#F9AC07" />
                      </svg>
                      <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                          fill="#F9AC07" />
                      </svg>
                      <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                          fill="#F9AC07" />
                      </svg>
                    </div>
                    <div class="review-content-text" data-attribute="review-content">
                      <h3>“He says they’re the most comfortable underwear he owns.”</h3>
                      <p>"The fabric feels really premium and they fit him perfectly. Definitely a confidence boost."
                      </p>
                    </div>
                    <div class="review-name" data-attribute="review-name">Lauren S.</div>
                    <div class="verified-buyer">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M7.975 0L9.60625 1.8125L11.9625 1.0875L12.5063 3.44375L14.8625 3.9875L14.1375 6.34375L15.95 7.975L14.1375 9.60625L14.8625 11.9625L12.5063 12.5063L11.9625 14.8625L9.60625 14.1375L7.975 15.95L6.34375 14.1375L3.9875 14.8625L3.44375 12.5063L1.0875 11.9625L1.8125 9.60625L0 7.975L1.8125 6.34375L1.0875 3.9875L3.44375 3.44375L3.9875 1.0875L6.34375 1.8125L7.975 0Z"
                          fill="#42ADA4" />
                        <path
                          d="M11.8173 4.56738L6.88729 9.49738L4.85728 7.46738L3.84229 8.48238L6.88729 11.5274L12.8323 5.58238L11.8173 4.56738Z"
                          fill="#E3F2FD" />
                      </svg>
                      <span>verified buyer</span>
                    </div>
                  </div>
                </div>
              </div>
              <div data-attribute="item-review" class="item-review swiper-slide">
                <div class="content-item">
                  <div class="review-image-container">
                    <img loading="lazy" data-attribute="review-image"
                      src="https://cdn.skyfastimg.com/images/2026/03/20/image-69bcb88ea6fdfd932ad203a8.png?w=400&h=50&q=80"
                      alt="review image" class="review-image">
                  </div>
                  <div class="review-content">
                    <div data-attribute="wrap-stars" class="wrap-stars" data-value="5">
                      <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                          fill="#F9AC07" />
                      </svg>
                      <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                          fill="#F9AC07" />
                      </svg>
                      <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                          fill="#F9AC07" />
                      </svg>
                      <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                          fill="#F9AC07" />
                      </svg>
                      <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                          fill="#F9AC07" />
                      </svg>
                    </div>
                    <div class="review-content-text" data-attribute="review-content">
                      <h3>“Finally underwear that actually works.”</h3>
                      <p>"The breathable fabric makes a noticeable difference, especially during hot days."</p>
                    </div>
                    <div class="review-name" data-attribute="review-name">Chloe S.</div>
                    <div class="verified-buyer">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M7.975 0L9.60625 1.8125L11.9625 1.0875L12.5063 3.44375L14.8625 3.9875L14.1375 6.34375L15.95 7.975L14.1375 9.60625L14.8625 11.9625L12.5063 12.5063L11.9625 14.8625L9.60625 14.1375L7.975 15.95L6.34375 14.1375L3.9875 14.8625L3.44375 12.5063L1.0875 11.9625L1.8125 9.60625L0 7.975L1.8125 6.34375L1.0875 3.9875L3.44375 3.44375L3.9875 1.0875L6.34375 1.8125L7.975 0Z"
                          fill="#42ADA4" />
                        <path
                          d="M11.8173 4.56738L6.88729 9.49738L4.85728 7.46738L3.84229 8.48238L6.88729 11.5274L12.8323 5.58238L11.8173 4.56738Z"
                          fill="#E3F2FD" />
                      </svg>
                      <span>verified buyer</span>
                    </div>
                  </div>
                </div>
              </div>
              <div data-attribute="item-review" class="item-review swiper-slide">
                <div class="content-item">
                  <div class="review-image-container">
                    <img loading="lazy" data-attribute="review-image"
                      src="https://cdn.skyfastimg.com/images/2026/03/20/image-69bcb88ea6fdfd932ad203a8.png?w=400&h=50&q=80"
                      alt="review image" class="review-image">
                  </div>
                  <div class="review-content">
                    <div data-attribute="wrap-stars" class="wrap-stars" data-value="5">
                      <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                          fill="#F9AC07" />
                      </svg>
                      <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                          fill="#F9AC07" />
                      </svg>
                      <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                          fill="#F9AC07" />
                      </svg>
                      <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                          fill="#F9AC07" />
                      </svg>
                      <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                          fill="#F9AC07" />
                      </svg>
                    </div>
                    <div class="review-content-text" data-attribute="review-content">
                      <h3>“Finally underwear that actually works.”</h3>
                      <p>"The breathable fabric makes a noticeable difference, especially during hot days."</p>
                    </div>
                    <div class="review-name" data-attribute="review-name">Chloe S.</div>
                    <div class="verified-buyer">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M7.975 0L9.60625 1.8125L11.9625 1.0875L12.5063 3.44375L14.8625 3.9875L14.1375 6.34375L15.95 7.975L14.1375 9.60625L14.8625 11.9625L12.5063 12.5063L11.9625 14.8625L9.60625 14.1375L7.975 15.95L6.34375 14.1375L3.9875 14.8625L3.44375 12.5063L1.0875 11.9625L1.8125 9.60625L0 7.975L1.8125 6.34375L1.0875 3.9875L3.44375 3.44375L3.9875 1.0875L6.34375 1.8125L7.975 0Z"
                          fill="#42ADA4" />
                        <path
                          d="M11.8173 4.56738L6.88729 9.49738L4.85728 7.46738L3.84229 8.48238L6.88729 11.5274L12.8323 5.58238L11.8173 4.56738Z"
                          fill="#E3F2FD" />
                      </svg>
                      <span>verified buyer</span>
                    </div>
                  </div>
                </div>
              </div>
              <div data-attribute="item-review" class="item-review swiper-slide">
                <div class="content-item">
                  <div class="review-image-container">
                    <img loading="lazy" data-attribute="review-image"
                      src="https://cdn.skyfastimg.com/images/2026/03/20/image-69bcb88ea6fdfd932ad203a8.png?w=400&h=50&q=80"
                      alt="review image" class="review-image">
                  </div>
                  <div class="review-content">
                    <div data-attribute="wrap-stars" class="wrap-stars" data-value="5">
                      <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                          fill="#F9AC07" />
                      </svg>
                      <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                          fill="#F9AC07" />
                      </svg>
                      <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                          fill="#F9AC07" />
                      </svg>
                      <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                          fill="#F9AC07" />
                      </svg>
                      <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                          fill="#F9AC07" />
                      </svg>
                    </div>
                    <div class="review-content-text" data-attribute="review-content">
                      <h3>“Finally underwear that actually works.”</h3>
                      <p>"The breathable fabric makes a noticeable difference, especially during hot days."</p>
                    </div>
                    <div class="review-name" data-attribute="review-name">Chloe S.</div>
                    <div class="verified-buyer">
                      <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path
                          d="M7.975 0L9.60625 1.8125L11.9625 1.0875L12.5063 3.44375L14.8625 3.9875L14.1375 6.34375L15.95 7.975L14.1375 9.60625L14.8625 11.9625L12.5063 12.5063L11.9625 14.8625L9.60625 14.1375L7.975 15.95L6.34375 14.1375L3.9875 14.8625L3.44375 12.5063L1.0875 11.9625L1.8125 9.60625L0 7.975L1.8125 6.34375L1.0875 3.9875L3.44375 3.44375L3.9875 1.0875L6.34375 1.8125L7.975 0Z"
                          fill="#42ADA4" />
                        <path
                          d="M11.8173 4.56738L6.88729 9.49738L4.85728 7.46738L3.84229 8.48238L6.88729 11.5274L12.8323 5.58238L11.8173 4.56738Z"
                          fill="#E3F2FD" />
                      </svg>
                      <span>verified buyer</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>

        <div class="swiper-pagination"></div>
      </div>
    </div>
  </div>
</div>

`;
export default html;
